<div class="audit-response-table">
    <h3>
        Audit Response
    </h3>

    <pageable-table
        [items]="auditResponses"
        [paging]="paging"
        [columns]="getColumnMap()"
        (refreshData)="getAuditResponses($event)">
    </pageable-table>
</div>